import {VariantConfigT} from '@/lib/types/colors.types';

export const whiteConfig: VariantConfigT = {
  basic: {
    icon: 'black',
    iconHover: 'black',
    iconActive: 'black',
    hover: 'black',
    active: 'black',
  },
  outline: {
    icon: 'black',
    iconHover: 'black',
    iconActive: 'black',
    hover: 'black',
    active: 'black',
  },
  ghost: {
    icon: 'black',
    iconHover: 'black',
    iconActive: 'black',
    hover: 'black',
    active: 'black',
  },
  gradient: {
    icon: 'black',
    iconHover: 'black',
    iconActive: 'black',
    hover: 'black',
    active: 'black',
  },
  solid: {
    icon: 'black',
    iconHover: 'black',
    iconActive: 'black',
    hover: 'black',
    active: 'black',
  },
};
